export const REVENUE_TABLE = 'REVENUE_TABLE'
export const GROSSMARGIN_TABLE = 'GROSSMARGIN_TABLE'
export const EBITDAMARGIN_TABLE = 'EBITDAMARGIN_TABLE'
export const OPERATINGMARGIN_TABLE = 'OPERATINGMARGIN_TABLE'
export const NETPROFITMARGIN_TABLE = 'NETPROFITMARGIN_TABLE'
export const INTERESTCOVERAGERATIO_TABLE = 'INTERESTCOVERAGERATIO_TABLE'
export const LEVERAGERELATIVETOEBITDA_TABLE = 'LEVERAGERELATIVETOEBITDA_TABLE'
export const LEVERAGERELATIVETOEQUITY_TABLE = 'LEVERAGERELATIVETOEQUITY_TABLE'
export const TANGIBLENETWORTHCOVERAABLE_TABLE = 'TANGIBLENETWORTHCOVERAABLE_TABLE'
export const CURRENTRATIO_TABLE = 'CURRENTRATIO_TABLE'
export const QUICKRATIO_TABLE = 'QUICKRATIO_TABLE'
export const CURRENTASSETSLIQUIDATION_TABLE = 'CURRENTASSETSLIQUIDATION_TABLE'
export const CASHCONVERSIONCYCLE_TABLE = 'CASHCONVERSIONCYCLE_TABLE'
// Assessment Part
export const GETRATINGASSESSMENT = 'GETRATINGASSESSMENT'
export const GETCOMBINEDASSESSMENT = 'GETCOMBINEDASSESSMENT'
export const GETLIQUIDITYASSESSMENT = 'GETLIQUIDITYASSESSMENT'

export const GETASSESMENTSCALE = 'GETASSESMENTSCALE'

export const POSTASSESMENT = 'POSTASSESMENT'
export const UPDATEASSESMENT = 'UPDATEASSESMENT'

export const GETASSESMENT = 'GETASSESMENT'
export const GETSINGLEASSESMENT = 'GETSINGLEASSESMENT'
export const EDITASSESMENT = 'EDITASSESMENT'

export const UPDATEASSESSMENTCOUNTER = 'UPDATEASSESSMENTCOUNTER'
export const DELETE_FINANCIAL_ASSESSMENT = 'DELETE_FINANCIAL_ASSESSMENT'

export const MOCKASSESSMENTENTRIES = 'MOCKASSESSMENTENTRIES'



// WEBPACK FOOTER //
// ./src/actions/assesment.js